module.exports = __webpack_public_path__ + "img/arrow-background.5fb3b07f.svg";